module.exports = __webpack_public_path__ + "img/Bodice-Front-B5-Gd-Da-Eb.0ea92e51.png";